import config from 'constants/config'
import { useResponsive } from 'hooks/useResponsive'
import { useLocation } from 'react-router-dom'

export default function useShowNewHotelSearch() {
  const location = useLocation()
  const configEnabled = config.ENABLE_HOTEL_SEARCH_PAGE_FILTER_PANE
  const [match] = useResponsive()
  const isDesktopAndHigher = !!(match?.desktop || match?.largeDesktop)
  const isMap = location.pathname.endsWith('/map')
  const isUltraLuxVertical = location.pathname.endsWith('/ultra-lux')

  return configEnabled && isDesktopAndHigher && !isMap && !isUltraLuxVertical
}
